import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import axios from 'axios'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'

const UpdateEvent = (props) => {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [status, setStatus] = useState('')
    const [location, setLocation] = useState('')
    const [difficulty, setDifficulty] = useState('')
    const [capacity, setCapacity] = useState('')

    useEffect(() => {
        if (props._id) {
            const event = props.events.find(({ _id }) => _id === props._id)
            setName(event.name)
            setDescription(event.description)
            setStatus(event.status)
            setLocation(event.location)
            setDifficulty(event.difficulty)
            setCapacity(event.capacity)
        }
    }, [props._id])

    const updateEvent = async e => {
        e.preventDefault()
        const updatedEvent = {
            _id: props._id, name, description, status, location, capacity, difficulty, company_id: "5f44f153841c2929c2eee625"
        }
        await axios.patch('/api/events', updatedEvent, tokenConfig())
            .then(res => {

                props.toggle(false)
                // Update Event List
                const updatedEvents = props.events.map(event => {
                    if (event._id === res.data._id) {
                        return res.data
                    }
                    return event
                })
                props.insertUpdatedEvent(updatedEvents)
            })
            .catch(err => console.log(err.message))
    }

    return (
        <Modal isOpen={props.updateEvent} size='lg' toggle={() => props.toggle(false)}>
            <ModalHeader toggle={() => props.toggle(false)}>Update Event</ModalHeader>
            <Form onSubmit={updateEvent}>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Event Name</Label>
                                <Input type="text" defaultValue={name} onChange={e => setName(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Description</Label>
                                <Input type="textarea" defaultValue={description} onChange={e => setDescription(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Difficulty</Label>
                                <Input type="select" defaultValue={difficulty} onChange={e => setDifficulty(e.target.value)} required>
                                    <option>Beginner</option>
                                    <option>Intermediate</option>
                                    <option>Hard</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Status</Label>
                                <Input type="select" defaultValue={status} onChange={e => setStatus(e.target.value)} required>
                                    <option>Open</option>
                                    <option>Closed</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Location</Label>
                                <Input type="text" defaultValue={location} onChange={e => setLocation(e.target.value)} required />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Capacity</Label>
                                <Input type="number" defaultValue={capacity} onChange={e => setCapacity(e.target.value)} required />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button type='submit' color="primary">Update</Button>{' '}
                    <Button color="secondary" onClick={() => props.toggle(false)}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default UpdateEvent;